import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export type SubmitAiFeedbackParams = {
  societyId: string;
  conversationId: string;
  messageId: string;
  feedback: 'positive' | 'negative';
};

export const submitAiFeedback = async ({
  societyId,
  conversationId,
  messageId,
  feedback,
}: SubmitAiFeedbackParams) => {
  const { data } = await axiosV2.post('/ai/feedback', {
    societyId,
    conversationId,
    messageId,
    feedback,
  });
  return decryptResponse(data);
};
